import React from 'react';
import { Form } from 'react-bootstrap';
import { AcPopover } from '../display/AcPopover';
import { AcFormFieldBadge } from './AcFormFieldBadge';
export const AcFormFieldLabel = ({ label, tooltip, className, required, readOnly, type, }) => {
    if (!label)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: "d-flex align-items-center" },
        React.createElement(Form.Label, { className: className }, label),
        tooltip && (React.createElement(Form.Label, { className: className },
            React.createElement(AcPopover, { placement: "top", text: tooltip, dark: true },
                React.createElement("i", { className: "fa text-secondary fa-question-circle fs-12 ml-2" })))),
        required && !readOnly && type && ['checkbox', 'radio', 'switch', 'custom'].includes(type) && (React.createElement("span", { className: "ml-2 mb-2" },
            React.createElement(AcFormFieldBadge, { type: "required" })))));
};
AcFormFieldLabel.displayName = 'AcFormFieldLabel';
